<template>
    <div>
        <div style="margin-bottom: 10px;">
            <el-input v-model="xueyuanMc" clearable placeholder="学生编码、学生姓名、联系电话、学生端手机号"
                      style="width: 400px;margin-right: 10px;"></el-input>
            <el-input v-model="banjiMc" clearable placeholder="班级" style="width: 150px;margin-right: 10px;"></el-input>
            <el-select v-model="ywcode" clearable placeholder="会员情况" style="width: 150px;margin-right: 10px;">
                <!-- <el-option v-for="item in ywList" :key="item.ywcode" :label="item.ywmc" :value="item.ywcode"></el-option> -->
                <el-option v-for="item in filterYwList" :key="item.ywcode" :label="item.ywmc" :value="item.ywcode"></el-option>
            </el-select>
            <el-button @click="searchClk" icon="el-icon-search">查询</el-button>
<!--        <el-button type="primary" @click="resetClk">重置</el-button>-->
            <el-button type="primary" @click="addClk" icon="el-icon-plus">新增</el-button>
        </div>
        <div>
            <el-button type="primary" @click="batchSetHyClk" icon="el-icon-date">批量设置会员日期</el-button>
            <el-button type="primary" @click="batchCancelHyClk" icon="el-icon-circle-close">批量取消会员</el-button>
            <el-button type="primary" @click="downloadTemplateClk" icon="el-icon-download">下载导入模板</el-button>
            <el-button type="primary" @click="batchImportClk" icon="el-icon-upload2">批量导入</el-button>
            <el-button type="primary" @click="exportClk" icon="el-icon-download">导出学员</el-button>
        </div>
        <el-table :data="tableData" border :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }" style="width: 100%;margin: 20px 0;" v-loading="loading"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" :selectable="checkSelectable"></el-table-column>
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="xueyuanBm" label="学生编码" width="140"></el-table-column>
            <el-table-column prop="xueyuanMc" label="学生姓名" min-width="100"></el-table-column>
            <el-table-column label="性别" width="60">
                <template slot-scope="scope">
                    <span v-if="scope.row.xb == 0">男</span>
                    <span v-if="scope.row.xb == 1">女</span>
                </template>
            </el-table-column>
            <el-table-column prop="xueyuanYwmc" label="学生英文名" min-width="100"></el-table-column>
            <el-table-column prop="lxdh" label="联系电话" width="120"></el-table-column>
            <el-table-column prop="banjiMc" label="所在班级" min-width="120"></el-table-column>
            <el-table-column label="学生端手机号" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.sjh">{{ scope.row.sjh }}</span>
                <span v-if="!scope.row.sjh">未绑定</span>
              </template>
            </el-table-column>
          <el-table-column label="会员期限" min-width="260">
            <template slot-scope="scope">
              <div v-for="(item, index) in scope.row.hyrqList" :key="index" style="font-size: 12px;">
                {{ getYwmc(item.ywcode) }} {{ formatDate(new Date(item.hyksrq), 'yyyy-MM-dd') }}~{{ formatDate(new Date(item.hyjsrq), 'yyyy-MM-dd') }}
              </div>
            </template>
          </el-table-column>
          <!--            <el-table-column prop="zhjfye" label="账户余额" width="100"></el-table-column>-->
            <el-table-column label="操作" width="280" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" @click="xqClk(scope.row.id)">详情</el-button>
                    <el-button type="text" v-if="scope.row.sjh" @click="czmmClk(scope.row.id)">重置密码</el-button>
<!--                    <el-button type="text" @click="ghbdClk(scope.row.id, scope.row.sjh)"
                        v-if="scope.row.sjh">更换绑定</el-button>
                    <el-button type="text" @click="bdxsdClk(scope.row.id)" v-if="!scope.row.sjh">绑定学生端</el-button>-->
                    <el-button type="text" @click="setHyClk(scope.row)">设置会员</el-button>
                    <el-button type="text" @click="bjClk(scope.row.id)">编辑</el-button>
                    <el-button type="text" @click="delClk(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="page-zj" v-if="tableData.length" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page="page" :page-sizes="[10, 30, 50, 100, 200]"
            :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="total"
            style="text-align: right;">
        </el-pagination>
        <!-- 新增 -->
        <el-dialog :title="title" :visible.sync="dialogVisible" width="30%" @close="handleClose" v-loading="diaLoading"
            class="addCls" :close-on-click-modal="false">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
<!--                <el-form-item label="学生编码" prop="xueyuanBm">
                    <el-input v-model="ruleForm.xueyuanBm" clearable placeholder="请输入学生编码"
                        :disabled="title == '详情'" show-word-limit maxlength="20"></el-input>
                </el-form-item>-->
                <el-form-item label="学生姓名" prop="xueyuanMc">
                    <el-input v-model="ruleForm.xueyuanMc" clearable placeholder="请输入学生姓名"
                        :disabled="title == '详情'" show-word-limit maxlength="30"></el-input>
                </el-form-item>
                <el-form-item label="学生英文名" prop="xueyuanYwmc">
                    <el-input v-model="ruleForm.xueyuanYwmc" clearable placeholder="请输入学生英文名"
                        :disabled="title == '详情'" show-word-limit maxlength="30"></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="xb">
                    <el-radio-group v-model="ruleForm.xb" :disabled="title == '详情'">
                        <el-radio :label="0">男</el-radio>
                        <el-radio :label="1">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="联系电话" prop="lxdh">
                    <el-input v-model="ruleForm.lxdh" clearable placeholder="请输入联系电话"
                        :disabled="title == '详情'" show-word-limit maxlength="11"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer" v-if="title != '详情'">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="xsglSave('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 绑定学生端 -->
        <el-dialog :title="titleBd" :visible.sync="dialogVisibleBd" width="30%" @close="handleCloseBd"
            v-loading="diaLoadingBd" class="addCls" :close-on-click-modal="false">
            <el-form :model="ruleFormBd" :rules="rulesBd" ref="ruleFormBd" label-width="80px">
                <el-form-item label="手机号" prop="sjh">
<!--                    <el-autocomplete class="inline-input" value-key="sjh" v-model="ruleFormBd.sjh"
                        :fetch-suggestions="querySearch" placeholder="请输入手机号" @select="handleSelect"
                        style="width: 100%;"></el-autocomplete>-->
                    <div style="display: flex;justify-content: space-between;">
                        <el-input v-model="ruleFormBd.sjh" @blur="checkSjhBlur"></el-input>
                        <el-button v-if="yzmShow && !hqyzmStatus" style="margin-left: 15px;" @click="yzmClk">{{ yzmTxt }}</el-button>
                        <div v-if="hqyzmStatus" style="width: 126px;flex-shrink: 0;text-align: center;">{{ yzmNum }}s后重发</div>
                    </div>
                  <div v-if="yzmShow" style="color: #F56C6C;font-size: 12px;position: absolute;line-height: 20px;bottom: -20px;">{{bdErrMsg}}</div>
                  <div v-if="!yzmShow && bdErrMsg" style="color: #F56C6C;font-size: 12px;position: absolute;line-height: 20px;bottom: -20px;">{{bdErrMsg}}</div>
                </el-form-item>
                <el-form-item v-if="yzmShow" label="验证码" prop="yzm" :rules="[
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ]">
                    <el-input v-model="ruleFormBd.yzm"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleBd = false">取 消</el-button>
                <el-button type="primary" @click="xsglSaveBd('ruleFormBd')">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 修改密码 -->
        <el-dialog title="设置密码" :close-on-click-modal="false" :visible.sync="dialogEditPwdForm" width="600px">
            <div class="newpassword" style="margin-bottom: 10px">
                <label style="margin-left: 28px">新密码: &nbsp;&nbsp;</label>
                <el-input style="display: inline-block;width: 80%" v-model="newpassword" type="password" show-password
                    :placeholder="pwdTipe"></el-input>
            </div>
            <div class="repassword">
                <label>新密码确认: &nbsp;&nbsp;</label>
                <el-input style="display: inline-block;width: 80%" v-model="repassword" type="password" show-password
                    :placeholder="'新' + pwdTipe"></el-input>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEditPwdForm = false">取 消</el-button>
                <el-button type="primary" @click="eidtPassword()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 设置会员 -->
        <el-dialog title="设置会员" :visible.sync="dialogVisibleHy" width="600px" @close="handleCloseHy" :close-on-click-modal="false" class="addCls">
            <el-form :model="ruleFormHy" ref="ruleFormHy" label-width="100px">
                <el-form-item label="业务办理">
                    <div v-for="(item, index) in ruleFormHy.hyList" :key="index" style="margin-bottom: 5px; display: flex; align-items: center;">
                        <el-checkbox v-model="item.checked" @change="handleHyChange" :title="item.ywmc" style="width: 120px; flex-shrink: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-right: 10px;">{{ item.ywmc }}</el-checkbox>
                        <el-date-picker
                            v-if="item.checked"
                            v-model="item.dateRange"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始"
                            end-placeholder="结束"
                            value-format="yyyy-MM-dd"
                            style="flex: 1;"
                            size="small">
                        </el-date-picker>
                    </div>
                </el-form-item>

                <el-form-item label="手机号" prop="sjh" :rules="[
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3456789]\d{9}$/, message: '请输入有效的手机号', trigger: 'blur' }
                ]">
                    <div style="display: flex;justify-content: space-between; align-items: center;">
                        <el-input v-model="ruleFormHy.sjh" placeholder="请输入手机号" style="flex: 1;" @change="checkHySjhBlur" :disabled="!ruleFormHy.hyList.some(item => item.checked)"></el-input>
                        <el-button v-if="hyYzmShow && !hyHqyzmStatus" style="margin-left: 10px;" @click="hyYzmClk" size="small">{{ hyYzmTxt }}</el-button>
                        <div v-if="hyHqyzmStatus" style="width: 100px;flex-shrink: 0;text-align: center; font-size: 12px; color: #909399;">{{ hyYzmNum }}s后重发</div>
                    </div>
                     <div v-if="hySjhErrMsg" style="color: #F56C6C;font-size: 12px;line-height: 20px;">{{hySjhErrMsg}}</div>
                </el-form-item>

                <el-form-item label="验证码" v-if="hyYzmShow" prop="yzm" :rules="[
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ]">
                    <el-input v-model="ruleFormHy.yzm" placeholder="请输入验证码"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleHy = false">取 消</el-button>
                <el-button type="primary" @click="saveHy">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 批量设置会员日期 -->
        <el-dialog title="批量设置会员日期" :visible.sync="dialogVisibleBatch" width="30%" class="addCls" :close-on-click-modal="false">
            <el-form :model="ruleFormBatch" ref="ruleFormBatch" label-width="80px">
                <el-form-item label="业务办理" prop="ywcode">
                    <el-radio-group v-model="ruleFormBatch.ywcode">
                        <el-radio v-for="item in ywList" :key="item.ywcode" :label="item.ywcode" style="margin-bottom: 10px;">{{item.ywmc}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="会员期限" prop="dateRange">
                    <el-date-picker
                        v-model="ruleFormBatch.dateRange"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        style="width: 100%;">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleBatch = false">取 消</el-button>
                <el-button type="primary" @click="batchSaveHy">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 批量取消会员 -->
        <el-dialog title="批量取消会员" :visible.sync="dialogVisibleBatchCancel" width="30%" class="addCls" :close-on-click-modal="false">
            <el-form :model="ruleFormBatchCancel" ref="ruleFormBatchCancel" label-width="80px">
                <el-form-item label="业务办理" prop="ywcode">
                    <el-radio-group v-model="ruleFormBatchCancel.ywcode">
                        <el-radio v-for="item in ywList" :key="item.ywcode" :label="item.ywcode" style="margin-bottom: 10px;">{{item.ywmc}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleBatchCancel = false">取 消</el-button>
                <el-button type="primary" @click="batchCancelHySave">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 批量导入 -->
        <el-dialog title="批量导入学员" :visible.sync="dialogVisibleImport" width="30%" class="addCls" :close-on-click-modal="false" @close="handleCloseImport">
            <el-form :model="ruleFormImport" ref="ruleFormImport" label-width="80px">
                <el-form-item label="业务办理" prop="ywcode">
                    <el-radio-group v-model="ruleFormImport.ywcode">
                        <el-radio v-for="item in ywList" :key="item.ywcode" :label="item.ywcode">{{item.ywmc}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="会员期限" prop="dateRange">
                    <el-date-picker
                        v-model="ruleFormImport.dateRange"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        style="width: 100%;">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="上传文件" prop="file">
                     <el-upload
                        class="upload-demo"
                        ref="uploadImport"
                        :action="importAction"
                        :limit="1"
                        :on-change="handleFileChange"
                        :on-remove="handleFileRemove"
                        :auto-upload="false"
                        :file-list="fileList"
                        :data="importData"
                        :on-success="handleImportSuccess"
                        :on-error="handleImportError"
                        accept=".xls,.xlsx"
                        name="file">
                        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件</div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleImport = false">取 消</el-button>
                <el-button type="primary" @click="batchImportSave" :loading="importLoading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'studentList',
    data() {
        return {
            jgglId: sessionStorage.getItem("jgglId"),
            tableData: [],
            page: 1,
            size: 10,
            xueyuanMc: '',
            banjiMc: '',
            ywcode: '',
            ywList: [],
            filterYwList: [],
            total: 0,
            title: '新增',
            dialogVisible: false,
            dialogVisibleBd: false,
            diaLoading: false,
            diaLoadingBd: false,
            loading: false,
            detailId: '',
            ruleForm: {
                xb: 0
            },
            rules: {
                /*xueyuanBm: [
                    { required: true, message: '请输入学生编码', trigger: 'blur' }
                ],*/
                xueyuanMc: [
                    { required: true, message: '请输入学生姓名', trigger: 'blur' }
                ],
                xueyuanYwmc: [
                    { required: true, message: '请输入学生英文名', trigger: 'blur' }
                ],
                xb: [
                    { required: true, message: '请选择性别', trigger: 'change' }
                ],
                lxdh: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' },
                    { pattern: /^1[3456789]\d{9}$/, message: '请输入有效的联系电话', trigger: 'blur' }
                ],
            },
            ruleFormBd: {
                sjh: '',
                yzm: '',
            },
            rulesBd: {
                sjh: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3456789]\d{9}$/, message: '请输入有效的手机号', trigger: 'blur' }
                ],
            },
            titleBd: '绑定学生端',
            bdId: '',
            bdlx: '',
            bdErrMsg: '',
            yonghuList: [],
            czmmId: '',
            dialogEditPwdForm: false,
            newpassword: '',//新密码
            repassword: '',//确认密码
            passwordRule: '^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>|\[\]\\\/?])[\S\s]{8,16}$',
            pwdTipe: '密码应由8到16位且包含大小写字母、特殊符号和数字组成',
            yzmShow: false,  // 验证码显示
            hqyzmStatus: false,
            yzmNum: 60,
            timer: null,
            yzmTxt: "获取验证码",
            dialogVisibleHy: false,
            ruleFormHy: {
                sjh: '',
                hyList: [],
                yzm: ''
            },
            hySjhErrMsg: '',
            hyYzmShow: false,
            hyHqyzmStatus: false,
            hyYzmNum: 60,
            hyYzmTxt: '获取验证码',
            hyTimer: null,
            currentHyXueyuanId: '',
            originalSjh: '', // 保存原始手机号
            dialogVisibleBatch: false,
            ruleFormBatch: {
                ywcode: '',
                dateRange: []
            },
            dialogVisibleBatchCancel: false,
            ruleFormBatchCancel: {
                ywcode: ''
            },
            selectionList: [],
            dialogVisibleImport: false,
            ruleFormImport: {
                ywcode: '',
                dateRange: [],
            },
            fileList: [],
            importLoading: false,
            importAction: 'api/xueyuan/XueyuanController/xueyuanImport',
        }
    },
    computed: {
        importData() {
            return {
                ywcode: this.ruleFormImport.ywcode,
                hyksrq: this.ruleFormImport.dateRange && this.ruleFormImport.dateRange[0] ? this.ruleFormImport.dateRange[0] : '',
                hyjsrq: this.ruleFormImport.dateRange && this.ruleFormImport.dateRange[1] ? this.ruleFormImport.dateRange[1] : '',
                jgglId: this.jgglId,
                access_token: sessionStorage.getItem("access_token")
            };
        }
    },
    created() {
      this.getConfigInfo();
      this.findJgYwList();
      this.queryStudentPage();
      this.queryUserList();
    },
    methods: {
        handleSelectionChange(val) {
            this.selectionList = val;
        },
        checkSelectable(row) {
            return row.sjh && row.sjh.length > 0;
        },
        batchSetHyClk() {
            if (this.selectionList.length === 0) {
                this.$message.warning('请选择要设置的学生');
                return;
            }
            this.ruleFormBatch = {
                ywcode: '',
                dateRange: []
            };
            this.dialogVisibleBatch = true;
        },
        batchSaveHy() {
            if (!this.ruleFormBatch.ywcode) {
                this.$message.warning('请选择会员情况');
                return;
            }
            if (!this.ruleFormBatch.dateRange || this.ruleFormBatch.dateRange.length < 2) {
                this.$message.warning('请选择会员期限');
                return;
            }
            
            const params = {
                xueyuanIds: this.selectionList.map(item => item.id).join(','),
                ywcode: this.ruleFormBatch.ywcode,
                hyksrq: this.ruleFormBatch.dateRange[0],
                hyjsrq: this.ruleFormBatch.dateRange[1],
                jgglId: this.jgglId
            };
            
            this.$post('xueyuan/XueyuanController/xueyuanPlHyrqSave', params).then(res => {
                if (res.code == 1) {
                    if(res.result.message){
                      this.$message.warning(res.result.message);
                    }else{
                      this.$message.success(res.result.mes ||'操作成功');
                    }
                    this.dialogVisibleBatch = false;
                    this.queryStudentPage();
                } else {
                    this.$message.error(res.msg || '操作失败');
                }
            });
        },
        batchCancelHyClk() {
            if (this.selectionList.length === 0) {
                this.$message.warning('请选择要取消的学生');
                return;
            }
            this.ruleFormBatchCancel = {
                ywcode: ''
            };
            this.dialogVisibleBatchCancel = true;
        },
        batchImportClk() {
            this.ruleFormImport = {
                ywcode: '',
                dateRange: []
            };
            this.fileList = [];
            this.dialogVisibleImport = true;
        },
        handleCloseImport() {
            this.dialogVisibleImport = false;
            this.fileList = [];
            this.importLoading = false;
        },
        handleFileChange(file, fileList) {
            this.fileList = fileList;
        },
        handleFileRemove(file, fileList) {
            this.fileList = fileList;
        },
        batchImportSave() {
            if (!this.ruleFormImport.ywcode) {
                this.$message.warning('请选择会员情况');
                return;
            }
            if (!this.ruleFormImport.dateRange || this.ruleFormImport.dateRange.length < 2) {
                this.$message.warning('请选择会员期限');
                return;
            }
            if (this.fileList.length === 0) {
                this.$message.warning('请上传文件');
                return;
            }

            this.importLoading = true;
            this.$refs.uploadImport.submit();
        },
        handleImportSuccess(response, file, fileList) {
            this.importLoading = false;
            if (response.code == '1') {
                 let msg = response.result && response.result.message ? response.result.message : response.msg;
                 if(response.result.message){
                   this.$message.warning(msg);
                 }else{
                   this.$message.success("导入成功");
                 }
                 this.dialogVisibleImport = false;
                 this.queryStudentPage();
            } else {
                 this.$message.error(response.msg || '导入失败');
            }
            this.fileList = [];
        },
        handleImportError(err, file, fileList) {
            this.importLoading = false;
            this.$message.error('上传失败');
        },
        downloadTemplateClk() {
            var access_token = sessionStorage.getItem("access_token");
            let url = "api/xueyuan/XueyuanController/DownloadXueyuanTemplate";
            url = url + "?access_token=" + access_token;
            window.location.href = url;
        },
        // 导出学员
        exportClk() {
            var access_token = sessionStorage.getItem("access_token");
            let url = "api/xueyuan/XueyuanController/xueyuanExport";
            url = url + "?access_token=" + access_token + "&jgglId=" + this.jgglId;
            if (this.xueyuanMc) {
                url = url + "&xueyuanMc=" + this.xueyuanMc;
            }
            if (this.banjiMc) {
                url = url + "&banjiMc=" + this.banjiMc;
            }
            if (this.ywcode) {
                if (this.ywcode === 'no_hy') {
                    url = url + "&noHy=1";
                } else if (this.ywcode.startsWith('no_')) {
                    url = url + "&noYwcode=" + this.ywcode.substring(3);
                } else {
                    url = url + "&ywcode=" + this.ywcode;
                }
            }
            window.location.href = url;
        },
        batchCancelHySave() {
            if (!this.ruleFormBatchCancel.ywcode) {
                this.$message.warning('请选择会员情况');
                return;
            }
            
            const params = {
                xueyuanIds: this.selectionList.map(item => item.id).join(','),
                ywcode: this.ruleFormBatchCancel.ywcode,
                jgglId: this.jgglId
            };
            
            this.$post('xueyuan/XueyuanController/xueyuanPlHyCancel', params).then(res => {
                if (res.code == 1) {
                    this.$message.success(res.message || '操作成功');
                    this.dialogVisibleBatchCancel = false;
                    this.queryStudentPage();
                } else {
                    this.$message.error(res.message || '操作失败');
                }
            });
        },
      // 获取业务列表
      findJgYwList(){
        var _this = this;
        _this.$post('bjgl/JgglController/findJgglYwListByJgglId', {jgglId: _this.jgglId}).then((rep) => {
          if (rep.code == 1) {
            _this.ywList = rep.result.ywList;
            
            // 构造筛选用的会员列表（包含无会员选项）
            _this.filterYwList = JSON.parse(JSON.stringify(_this.ywList));
            _this.filterYwList.unshift({ ywcode: 'no_hy', ywmc: '无会员' });
            if (_this.ywList && _this.ywList.length > 0) {
                _this.ywList.forEach(item => {
                    _this.filterYwList.push({
                        ywcode: 'no_' + item.ywcode,
                        ywmc: '无' + item.ywmc
                    });
                });
            }
          } else {
            _this.$message({
              type: "error",
              message: rep.msg
            });
          }
        })
      },
      //获取系统配置信息
      getConfigInfo(){
        this.$post('sys/findSysConfigByConfigKey',{configKey: "password_rule"}).then((arg) => {
          this.passwordRule = arg.result.sysConfig.configValue;
          this.pwdTipe = arg.result.sysConfig.configDes;
        })
      },
      //修改密码
      eidtPassword() {
          if (this.newpassword == "") {
              this.$message({
                  type: "error",
                  message: "请输入新密码"
              });
              return;
          } else {
              var checkPwd = this.checkPwd(this.newpassword, this.passwordRule);
              if (!checkPwd) {
                  this.$message({
                      type: "error",
                      message: "新" + this.pwdTipe
                  });
                  return;
              }
          }
          if (this.repassword == "") {
              this.$message({
                  type: "error",
                  message: "请输入确认密码"
              });
              return;
          } else {
              var checkPwd = this.checkPwd(this.repassword, this.passwordRule);
              if (!checkPwd) {
                  this.$message({
                      type: "error",
                      message: "确认" + this.pwdTipe
                  });
                  return;
              } else {
                  if (this.newpassword != this.repassword) {
                      this.$message({
                          type: "error",
                          message: "两次密码不一致"
                      });
                      return;
                  }
              }
          }
          var _this = this;
          var params = {
              "userId": this.czmmId,
              "newPassword": this.newpassword
          };
          _this.$post("user/eidtPassword", params).then(function (response) {
              if (response.result == "1") {
                  _this.$message({
                      type: "success",
                      message: response.message
                  });
                  _this.dialogEditPwdForm = false;
                  _this.queryStudentPage();
              } else {
                  _this.$message({
                      type: "error",
                      message: response.message
                  });
              }
          }).catch(function (error) {
              // console.error(err);
          });
      },
      handleSelect(item) {
          console.log(item);
      },
        // 验证码获取
        yzmClk(){
            var _this = this;
            _this.$post("getValidCode", { sjh: _this.ruleFormBd.sjh ,codeType: 'xsbind'}).then(function (res) {
              if (res.code == "1") {
                _this.hqyzmStatus = true;
                _this.timer = setInterval(() => {
                    _this.yzmNum--;
                    if(_this.yzmNum == 0){
                        _this.hqyzmStatus = false;
                        _this.yzmNum = 60;
                        _this.yzmTxt = '重新发送';
                        clearInterval(_this.timer);
                    }
                }, 1000);
              }
            })
        },
      checkSjhBlur(){
        var _this = this;
        _this.yzmShow = false;
        _this.ruleFormBd.yzm = '';
        // 先触发表单验证
        _this.$refs['ruleFormBd'].validateField('sjh', (errorMessage) => {
          // 表单验证完成后执行的逻辑
          if (!errorMessage) {
            var params = {
              "sjh": _this.ruleFormBd.sjh
            };
            _this.$post("user/yonghuList", params).then(function (res) {
              if (res.code == "1") {
                var user = res.result.yonghuList;
                if (user.length > 0) {
                  for(var i = 0; i < user.length; i++){
                    if(user[i].xueyuanId != _this.bdId && user[i].yhlx == '101005'){
                      _this.bdErrMsg = "手机号已被其他学生绑定";
                      _this.yzmShow = true;
                    }
                  }
                  /*if (user[0].xueyuanId != _this.bdId) {
                    if(user[0].yhlx == '101005'){
                      _this.bdErrMsg = "手机号已被其他学生绑定";
                      _this.yzmShow = true;
                    }/!*else if(user[0].yhlx == '101007'){
                      _this.bdErrMsg = "手机号已注册，点击获取验证码绑定学生";
                      _this.yzmShow = true;
                    }else if(user[0].yhlx != '101005' && user[0].yhlx != '101007'){
                      _this.bdErrMsg = "手机号已被其他教师绑定";
                    }*!/
                  }*/
                }
              }
            })
          }
        });
      },
      querySearch(queryString, cb) {
          this.$forceUpdate();
          var yonghuList = this.yonghuList, results = [];
          if (queryString) {
              results = yonghuList.filter(item => {
                //return item.sjh.indexOf(queryString) > -1;
                if(item.sjh){
                  return item.sjh.indexOf(queryString) > -1;
                }
              })
          } else {
              var results = yonghuList;
          }
          // 调用 callback 返回建议列表的数据
          cb(results);
      },
      createFilter(queryString) {
          return (restaurant) => {
              return (restaurant.sjh.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
          };
      },
      // 查询user列表
      queryUserList() {
          this.$post("user/yonghuList", { yhlx: '101007' }, "json").then(res => {
              if (res.code == 1) {
                  this.yonghuList = res.result.yonghuList;
              } else {
                  this.$message({
                      type: "error",
                      message: res.msg
                  });
              }
          })
      },
      // 绑定手机号/更改绑定
      xsglSaveBd(ruleForm) {
          this.$refs[ruleForm].validate((valid) => {
              if (valid) {
                  if(!this.yzmShow && this.bdErrMsg){
                    return;
                  }
                  this.diaLoadingBd = true;
                  var params = {
                      "id": this.bdId,
                      "lx": this.bdlx,
                      "sjh": this.ruleFormBd.sjh,
                      "yzm": this.ruleFormBd.yzm
                  };
                  this.$post("xueyuan/XueyuanController/xueyuanBangding", params).then(res => {
                      this.diaLoadingBd = false;
                      if (res.code == 1) {
                          this.$message({
                              type: "success",
                              message: res.msg
                          });
                          this.dialogVisibleBd = false;
                          this.queryStudentPage();
                      } else {
                          this.$message({
                              type: "error",
                              message: res.msg
                          });
                      }
                  })
              }
          })
      },
      // 新增/编辑
      xsglSave(ruleForm) {
          this.$refs[ruleForm].validate((valid) => {
              if (valid) {
                  this.diaLoading = true;
                  this.$post("xueyuan/XueyuanController/xueyuanSave", { ...this.ruleForm, jgglId: this.jgglId }, "json").then(res => {
                      this.diaLoading = false;
                      if (res.code == 1) {
                          this.$message({
                              type: "success",
                              message: res.msg
                          });
                          this.dialogVisible = false;
                          this.queryStudentPage();
                      } else {
                          this.$message({
                              type: "error",
                              message: res.msg
                          });
                      }
                  })
              }
          })
      },
      // 弹窗关闭时
      handleClose() {
          this.ruleForm = {
              xb: 0
          };
          this.$refs['ruleForm'].resetFields();
      },
      // 弹窗关闭时
      handleCloseBd() {
          this.ruleFormBd = {
              sjh: '',
              yzm: '',
          };
          this.yzmShow = false;
          this.bdErrMsg = '';
          clearInterval(this.timer);
          this.yzmNum = 60;
          this.yzmTxt = '获取验证码';
          this.hqyzmStatus = false;
          this.$refs['ruleFormBd'].resetFields();
      },
      // 新增
      addClk() {
          this.title = '新增';
          this.dialogVisible = true;
      },
      // 每页条数
      handleSizeChange(val) {
          this.size = val;
          this.queryStudentPage();

      },
      // 当前页
      handleCurrentChange(val) {
          this.page = val;
          this.queryStudentPage();
      },
      // 搜索
      searchClk() {
          this.page = 1;
          this.queryStudentPage();
      },
      // 重置
      resetClk() {
          this.page = 1;
          this.xueyuanMc = '';
          this.banjiMc = '';
          this.ywcode = '';
          this.queryStudentPage();
      },
      // 获取学生列表
      queryStudentPage() {
          this.loading = true;
          let params = {
              jgglId: this.jgglId,
              xueyuanMc: this.xueyuanMc,
              banjiMc: this.banjiMc,
              page: this.page - 1,
              size: this.size
          };
          
          if (this.ywcode) {
              if (this.ywcode === 'no_hy') {
                  params.noHy = '1';
              } else if (this.ywcode.startsWith('no_')) {
                  params.noYwcode = this.ywcode.substring(3);
              } else {
                  params.ywcode = this.ywcode;
              }
          }
 
           // this.$post("xueyuan/XueyuanController/xueyuanPage", { jgglId: this.jgglId, xueyuanMc: this.xueyuanMc, banjiMc: this.banjiMc, ywcode: this.ywcode, page: this.page - 1, size: this.size }).then(res => {
           this.$post("xueyuan/XueyuanController/xueyuanPage", params).then(res => {
              this.loading = false;
              if (res.code == 1) {
                  this.tableData = res.result.page.content;
                  this.total = res.result.page.totalElements;

                // 如果当前页没有数据且不是第一页，则返回上一页
                if (this.tableData.length === 0 && this.page > 1) {
                  this.page -= 1;
                  this.queryStudentPage(); // 重新加载上一页数据
                }
              } else {
                  this.$message({
                      type: "error",
                      message: res.msg
                  });
              }
          })
      },
      // 详情接口
      queryDetail() {
          this.$post("xueyuan/XueyuanController/xueyuanView", { id: this.detailId }).then(res => {
              this.loading = false;
              if (res.code == 1) {
                  this.dialogVisible = true;
                  this.ruleForm = res.result.xueyuan;
              } else {
                  this.$message({
                      type: "error",
                      message: res.msg
                  });
              }
          })
      },
      // 详情
      xqClk(id) {
          this.title = '详情';
          this.detailId = id;
          this.queryDetail();
      },
      // 重置密码
      czmmClk(id) {
          var _this = this;
          _this.newpassword = '';
          _this.repassword = '';
          _this.$post('xueyuan/XueyuanController/findYonghuListByXueyuanId',{xueyuanId: id}).then((rep) => {
            if(rep.code == 1){
              var user =rep.result.yonghuList;
              if(user.length>0){
                _this.czmmId = rep.result.yonghuList[0].id;
                _this.dialogEditPwdForm = true;
              }else{
                _this.$message({
                  type: "error",
                  message: "无该学员用户信息"
                });
              }
            }else{
              _this.$message({
                type: "error",
                message: rep.msg
              });
            }
          })
      },
      // 更换绑定
      ghbdClk(id, sjh) {
          this.ruleFormBd.sjh = sjh;
          this.titleBd = '更改绑定学生端';
          this.bdId = id;
          this.bdlx = 1;
          this.dialogVisibleBd = true;
      },
      // 绑定学生端
      bdxsdClk(id) {
          this.titleBd = '绑定学生端';
          this.bdId = id;
          this.bdlx = 0;
          this.dialogVisibleBd = true;
      },
      // 编辑
      bjClk(id) {
          this.title = '编辑';
          this.detailId = id;
          this.queryDetail();
      },
      // 删除
      delClk(id) {
        this.$post("xueyuan/XueyuanController/xueyuanDelCheck", { id }).then(rep => {
          if (rep.code == 1) {
            var message =rep.result.message;
            this.$confirm(message ? message + ',是否继续?':'此操作将永久删除该学生, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$post("xueyuan/XueyuanController/xueyuanDel", { id }).then(res => {
                if (res.code == 1) {
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  });
                  this.queryStudentPage();
                } else {
                  this.$message({
                    type: "error",
                    message: res.msg
                  });
                }
              })

            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });
            });
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        })
      },
      // 设置会员
      setHyClk(row) {
          this.currentHyXueyuanId = row.id;
          this.ruleFormHy.sjh = row.sjh || '';
          this.originalSjh = row.sjh || ''; // 记录原始手机号

          const hyrqMap = {};
          if (row.hyrqList) {
              row.hyrqList.forEach(h => {
                  hyrqMap[h.ywcode] = h;
              });
          }

          // 初始化 hyList
          this.ruleFormHy.hyList = this.ywList.map(item => {
              const exist = hyrqMap[item.ywcode];
              return {
                  ywcode: item.ywcode,
                  ywmc: item.ywmc,
                  checked: !!exist,
                  dateRange: exist && exist.hyksrq && exist.hyjsrq ? [this.formatDate(exist.hyksrq, 'yyyy-MM-dd'), this.formatDate(exist.hyjsrq, 'yyyy-MM-dd')] : []
              };
          });

          this.dialogVisibleHy = true;
      },
      handleCloseHy() {
          this.dialogVisibleHy = false;
          this.ruleFormHy = {
              sjh: '',
              hyList: [],
              yzm: ''
          };
          this.hySjhErrMsg = '';
          this.hyYzmShow = false;
          this.hyHqyzmStatus = false;
          this.hyYzmNum = 60;
          this.hyYzmTxt = '获取验证码';
          if (this.hyTimer) {
              clearInterval(this.hyTimer);
              this.hyTimer = null;
          }
          this.$refs['ruleFormHy'].resetFields();
      },
      handleHyChange() {
        // 如果没有选择任何业务，恢复原始手机号
        const selectedHy = this.ruleFormHy.hyList.filter(item => item.checked);
        if (selectedHy.length === 0) {
            this.ruleFormHy.sjh = this.originalSjh;
        }
        this.validateUserStatus();
      },
      checkHySjhBlur() {
        this.ruleFormHy.yzm = '';
        this.validateUserStatus();
      },
      validateUserStatus() {
        return new Promise((resolve) => {
            this.hySjhErrMsg = '';

            const selectedHy = this.ruleFormHy.hyList.filter(item => item.checked);
            if (selectedHy.length === 0) {
                this.hyYzmShow = false;
                this.ruleFormHy.yzm = '';
                // 如果没有选择业务，不进行后续判断
                resolve(false);
                return;
            }

            // 先触发表单验证
            this.$refs['ruleFormHy'].validateField('sjh', (errorMessage) => {
                if (!errorMessage) {
                    var params = {
                        "sjh": this.ruleFormHy.sjh
                    };
                    this.$post('user/yonghuList', params).then((rep) => {
                        if (rep.code == 1) {
                            var user = rep.result.yonghuList;
                            let isPhoneBoundToOther = false;
                            let hasStudentUser = false;
                            let shouldShow = false;

                            if (user.length > 0) {
                                // 检查手机号是否被其他学生绑定
                                for(var i = 0; i < user.length; i++){
                                    if (user[i].yhlx == '101005') {
                                        const currentYw = user[i].ywList;

                                        if(currentYw.length > 0){
                                          // 检查手机号是否被其他学生绑定
                                          for (let item of currentYw) {
                                            // 检查当前遍历的业务是否在已选业务中
                                            const isSelected = selectedHy.some(sel => sel.ywcode == item.ywcode);
                                            if (isSelected && item.xueyuanId && item.xueyuanId != this.currentHyXueyuanId) {
                                              this.hySjhErrMsg = "手机号已被其他学生绑定";
                                              isPhoneBoundToOther = true;
                                              break;
                                            }
                                          }

                                          /*hasStudentUser = true;
                                          // 检查是否有勾选的业务 不存在于 当前用户的业务列表中
                                          const hasNew = selectedHy.some(selItem => {
                                            return !currentYw.some(existItem =>
                                                existItem.ywcode === selItem.ywcode && existItem.jgglId === this.jgglId
                                            );
                                          });
                                          if (hasNew) {
                                            shouldShow = true;
                                          }*/
                                        }
                                    }
                                }
                            }

                            // 如果没有找到101005类型的用户，说明是新绑定，需要显示验证码
                            /*if (!hasStudentUser) {
                                shouldShow = true;
                            }*/

                            // 如果手机号被其他学生绑定，则需要显示验证码
                            if (isPhoneBoundToOther) {
                                shouldShow = true;
                            }

                            if (!shouldShow && this.hyYzmShow) {
                                this.ruleFormHy.yzm = '';
                            }
                            this.hyYzmShow = shouldShow;

                            resolve(true);
                        } else {
                            resolve(false);
                        }
                    });
                } else {
                    resolve(false);
                }
            });
        });
      },
      hyYzmClk() {
          var sjh = this.ruleFormHy.sjh;
          if (!sjh) {
              this.$message.error('请输入手机号');
              return;
          }
          if (!/^1[3456789]\d{9}$/.test(sjh)) {
              this.$message.error('请输入有效的手机号');
              return;
          }

          this.$post("getValidCode", { sjh: sjh, codeType: 'xsbind' }).then((res) => {
              if (res.code == "1") {
                  this.$message.success('发送成功');
                  this.hyHqyzmStatus = true;
                  this.hyYzmTxt = this.hyYzmNum + 's后重发';
                  this.hyTimer = setInterval(() => {
                      if (this.hyYzmNum > 0) {
                          this.hyYzmNum--;
                          this.hyYzmTxt = this.hyYzmNum + 's后重发';
                      } else {
                          clearInterval(this.hyTimer);
                          this.hyTimer = null;
                          this.hyHqyzmStatus = false;
                          this.hyYzmNum = 60;
                          this.hyYzmTxt = '获取验证码';
                      }
                  }, 1000);
              } else {
                  this.$message.error(res.msg);
              }
          });
      },
      saveHy() {
          this.$refs['ruleFormHy'].validate((valid) => {
              if (valid) {
                  // 如果显示验证码框，必须输入验证码
                  if (this.hyYzmShow && !this.ruleFormHy.yzm) {
                      this.$message.error('请输入验证码');
                      return;
                  }

                  const selectedHy = this.ruleFormHy.hyList.filter(item => item.checked);
                /*if (selectedHy.length === 0) {
                    this.$message.error('请至少选择一个业务');
                    return;
                }*/

                  for (const item of selectedHy) {
                      if (!item.dateRange || item.dateRange.length !== 2) {
                          this.$message.error(`请选择 ${item.ywmc} 的日期范围`);
                          return;
                      }
                  }

                  var hyrqList = [];
                  for(var i = 0; i < this.ruleFormHy.hyList.length; i++){
                    if(this.ruleFormHy.hyList[i].checked){
                        hyrqList.push({
                          ywcode: this.ruleFormHy.hyList[i].ywcode,
                          ywmc: this.ruleFormHy.hyList[i].ywmc,
                          hyksrq: this.ruleFormHy.hyList[i].dateRange[0],
                          hyjsrq: this.ruleFormHy.hyList[i].dateRange[1],
                        });
                    }
                  }

                  const params = {
                      id: this.currentHyXueyuanId,
                      sjh: this.ruleFormHy.sjh,
                      hyrqList: hyrqList,
                      yzm: this.ruleFormHy.yzm,
                      jgglId: this.jgglId,
                  };

                  console.log(params);
                  this.loading = true;
                  this.$post("xueyuan/XueyuanController/saveStudentMembership", params, "json").then(res => {
                      this.loading = false;
                      if (res.code == 1) {
                          this.$message.success('设置成功');
                          this.dialogVisibleHy = false;
                          this.queryStudentPage();
                      } else {
                          this.$message.error(res.msg);
                      }
                  }).catch(() => {
                      this.loading = false;
                  });
              }
          });
      },
      // 获取业务名称
      getYwmc(code) {
          if (!this.ywList || this.ywList.length === 0) return code;
          const found = this.ywList.find(item => item.ywcode === code);
          return found ? found.ywmc : code;
      },
      formatDate(date, fmt) {
          if (!date) return '';
          if (typeof date === 'string') {
              date = new Date(date);
          }
          if (isNaN(date.getTime())) return '';
          
          const o = {
              'M+': date.getMonth() + 1,
              'd+': date.getDate(),
              'h+': date.getHours(),
              'm+': date.getMinutes(),
              's+': date.getSeconds(),
              'q+': Math.floor((date.getMonth() + 3) / 3),
              'S': date.getMilliseconds()
          };
          if (/(y+)/.test(fmt)) {
              fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
          }
          for (const k in o) {
              if (new RegExp('(' + k + ')').test(fmt)) {
                  fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
              }
          }
          return fmt;
      },
    },
    beforeDestroy(){
        clearInterval(this.timer);
    },
}
</script>

<style>
.addCls .el-dialog__body {
    padding-right: 40px !important;
}
/* 修复日期选择器“至”字显示不全的问题 */
.el-date-editor .el-range-separator {
    width: auto !important;
    padding: 0 5px !important;
}
/* 覆盖 el-radio-group 的默认样式，修复换行间距问题 */
.el-radio-group {
    font-size: 14px !important;
    line-height: inherit !important;
}
</style>
<style lang="less" scoped>
.el-table {
    .el-button {
        padding: 0;
    }
}
</style>
